<template>
    <form-row title="Does Any Portion Go Towards Purchase Price?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="option_fee_toward_purchase"
                v-model="option_fee_toward_purchase"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>

        <div v-if="option_fee_toward_purchase" class="flex mt-4 items-center">
            <div class="flex-none sm:w-36 my-2">
                <div v-show="option_fee_toward_purchase_by_percent">
                    <input-money
                        :value="option_fee_toward_purchase_by_percent"
                        tabindex="-1"
                        :read_only="true"
                    />
                </div>

                <div v-show="! option_fee_toward_purchase_by_percent">
                    <input-money
                        v-model="option_fee_toward_purchase_entered"
                        :read_only="read_only"
                    />
                </div>

                <input
                    name="option_fee_toward_purchase_amount"
                    type="hidden"
                    :value="option_fee_toward_purchase_amount"
                    :read_only="true"
                />
            </div>

            <div class="flex flex-1 items-center my-2">
                <span class="text-sm text-gray-600 sm:pl-6 pr-6">
                    {{ $t('- OR -') }}
                </span>

                <div class="w-1/4 sm:w-1/5">
                    <input-percent
                        name="option_fee_toward_purchase_percent"
                        v-model="option_fee_toward_purchase_percent"
                        :read_only="read_only"
                    />
                </div>

                <span class="text-sm text-gray-600 leading-snug pl-4">
                    {{ $t('of') }} {{ total_option_fee_formatted }} <br>{{ $t('total option fee') }}
                </span>
            </div>
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        commercial: { default: () => ({}) },
        option_fee_amount: {},
        read_only: { default: false },
    },

    data() {
        return {
            option_fee_toward_purchase: this.commercial.option_fee_toward_purchase,
            option_fee_toward_purchase_percent:
                this.commercial.option_fee_toward_purchase_percent,
            option_fee_toward_purchase_entered:
                this.commercial.option_fee_toward_purchase_amount,
        }
    },

    computed: {
        total_option_fee() {
            return this.formatMoney(this.option_fee_amount);
        },
        option_fee_toward_purchase_by_percent() {
            return this.option_fee_toward_purchase_percent
                ? this.formatMoney((this.option_fee_toward_purchase_percent / 100) * this.moneyVal(this.total_option_fee))
                : null;
        },
        option_fee_toward_purchase_amount() {
            return this.option_fee_toward_purchase_by_percent || this.option_fee_toward_purchase_entered;
        },
        total_option_fee_formatted() {
            return this.total_option_fee && ! isNaN(this.total_option_fee)
                ? '$' + this.formatMoneyToString(this.total_option_fee)
                : '';
        },
    },
}
</script>
